import { ChangeDetectionStrategy, Component, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TemplateExportService } from '../../../../services/template-export.service';
import { ToastBarService } from '../../../../services/toast-bar.service';
import BlockModel from '../../../../models/email-template/block-model.interface';

/**
 * Region: the "Export content" popup from the mockup (.export-overlay >
 * .export-template-dialog) - a bespoke centered card with its own close
 * button, info-strip summary and two option cards, none of which map onto
 * the shared ng-bootstrap modal chrome the rest of the app uses. Kept as its
 * own self-contained *_v2 component (computes contentString itself from the
 * inputs) rather than routed through the base class's outputTextContent().
 */
@Component({
  selector: 'app-export-dialog-v2',
  imports: [CommonModule],
  templateUrl: './export-dialog-v2.component.html',
  styleUrl: './export-dialog-v2.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ExportDialogV2Component implements OnInit {
  @Input() templateName: string | null = null;
  @Input() language: string | null = null;
  @Input() selectedBlocks: BlockModel[] = [];
  @Input() variablesMaxLength: any[] = [];

  @Output() closeDialog = new EventEmitter<void>();

  protected contentString = '';
  protected fieldCount = 0;

  constructor(
    private templateExportService: TemplateExportService,
    private toastBarService: ToastBarService
  ) {}

  ngOnInit(): void {
    this.contentString = this.templateExportService.generateContentString(this.selectedBlocks, this.variablesMaxLength);
    this.fieldCount = this.templateExportService.getExportFieldCount(this.selectedBlocks, this.variablesMaxLength);
  }

  @HostListener('document:keydown.escape')
  protected onEscapeKey(): void {
    this.closeDialog.emit();
  }

  protected downloadFile(): void {
    this.templateExportService.downloadOutput(this.contentString, this.templateName || 'template');
    this.closeDialog.emit();
    this.toastBarService.showToastSuccess('Word file downloaded');
  }

  protected async copyToClipboard(): Promise<void> {
    try {
      await this.templateExportService.copyRichToClipboard(this.contentString);
      this.closeDialog.emit();
      this.toastBarService.showToastSuccess('Campaign copy copied');
    } catch {
      this.toastBarService.showToastError('Clipboard access was blocked');
    }
  }
}
